import { render, staticRenderFns } from "./electric-charge-chart.vue?vue&type=template&id=19f856cb&scoped=true&"
import script from "./electric-charge-chart.vue?vue&type=script&lang=js&"
export * from "./electric-charge-chart.vue?vue&type=script&lang=js&"
import style0 from "./electric-charge-chart.vue?vue&type=style&index=0&id=19f856cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f856cb",
  null
  
)

export default component.exports